import './CreateAccountPage.css';

import React from 'react';

import MarketingFooter
  from '../components/common/MarketingFooter/MarketingFooter';
import MarketingTopNav
  from '../components/common/MarketingTopNav/MarketingTopNav';
import PomPom from '../components/common/PomPom/PomPom';

const CreateAccountPage: React.FC = () => (
  <div className="ca-container">
    <MarketingTopNav />

    <div className="ca-gutter-pompoms" aria-hidden="true">
      <PomPom size="small" color="pink" className="ca-gutter-pompom ca-gutter-pompom-left-top" />
      <PomPom size="xlarge" color="teal" className="ca-gutter-pompom ca-gutter-pompom-right-top" />
      <PomPom size="medium" color="pink" className="ca-gutter-pompom ca-gutter-pompom-left-mid" />
      <PomPom size="large" color="teal" className="ca-gutter-pompom ca-gutter-pompom-right-mid" />
      <PomPom size="small" color="teal" className="ca-gutter-pompom ca-gutter-pompom-left-bottom" />
      <PomPom size="medium" color="pink" className="ca-gutter-pompom ca-gutter-pompom-right-bottom" />
      <PomPom size="xlarge" color="pink" className="ca-gutter-pompom ca-gutter-pompom-wide-left-top" />
      <PomPom size="xlarge" color="teal" className="ca-gutter-pompom ca-gutter-pompom-wide-right-top" />
      <PomPom size="large" color="teal" className="ca-gutter-pompom ca-gutter-pompom-wide-left-bottom" />
      <PomPom size="large" color="pink" className="ca-gutter-pompom ca-gutter-pompom-wide-right-bottom" />
    </div>

    <div className="ca-maxwidth-container">
      <section className="ca-hero">
        <PomPom size="large" color="pink" className="ca-hero-pompom ca-hero-pompom-top" />
        <PomPom size="medium" color="teal" className="ca-hero-pompom ca-hero-pompom-bottom" />

        <h1 className="ca-hero-title">
          Create<br />
          <span className="ca-hero-accent">Account</span>
        </h1>

        <p className="ca-hero-subtitle">
          CheerEval is currently in its beta, and not yet available to the
          public. Check back soon!
        </p>
        <p className="ca-hero-subtitle">
        For more info, or to request an invite, contact{' '}
          <a className="ca-hero-email" href="mailto:info@cheereval.ca">
            info@cheereval.ca
          </a>
        </p>
      </section>

      <div className="ca-pyramid-wrap">
        <img
          src="/images/construction/cheer_pyramid.svg"
          alt="Cheerleading pyramid"
          className="ca-pyramid"
        />
      </div>

      <MarketingFooter />
    </div>
  </div>
);

export default CreateAccountPage;
